import { useMemo } from 'react'

import { ActionTablePath } from '../../action-table/action-table'
import { useGetEmployeesQuery } from '../../../../api/plamo-api'
import { Link, useNavigate } from 'react-router-dom'
import { Breadcrumb } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { IconCircleUserSolid } from '../../../../icon'

function EmployeePage() {
  const navigate = useNavigate()
 
  const isLoading = false;
  
  const columns = useMemo(() => [
    {
      title: "Id",
      dataIndex: "id",
      sorter: true,
      filter: true,
      type: 'int',
    },
    {
      title: "Aktiv",
      dataIndex: "active",
      sorter: true,
      filter: true,
      type: 'boolean',
      width: 100,
    },
    {
      title: "Vorname",
      dataIndex: "firstName",
      sorter: true,
      filter: true,
      type: 'string',
      render: (value, item) => <Link to={`/employee/${item.id}`}>{ value }</Link>
    },
    {
      title: "Nachname",
      dataIndex: "lastName",
      sorter: true,
      filter: true,
      type: 'string',
      render: (value, item) => <Link to={`/employee/${item.id}`}>{ value }</Link>
    },
  ], [])

  return (
    <div>
      <Breadcrumb
          items={[
            {
              onClick: () => navigate('/'),
              title: <HomeOutlined />,
            },
            {
              title: (
                <>
                  <IconCircleUserSolid />
                  <span>Mitarbeitende</span>
                </>
              ),
            },            
          ]}
        />
      <ActionTablePath
          storageKey="employee"
          isParentLoading={isLoading}
          defaultSortKey="lastName"
          buttonRow={{
            buttons: [
              {
                text: 'Neu',
                buttonType: 'primary',
                onClick: () => navigate('./new')
              },
              {
                text: 'Suche zurücksetzen',
                onClick: () => navigate(`?filter=${btoa(JSON.stringify({ active: { comparator: "EQ", value: true, originalValue: true, displayValue: "Aktiv", title: "Aktiv" }}))}`)
              }
            ]
          }}
          tableData={{
            defaultSortKey: 'id',
            columns,
            dataSource: {
              pageableQueryEndpoint: useGetEmployeesQuery,
              queryResultMapping: (result) => result?.items
            },
            actions: [
              {
                caption: 'Bearbeiten',
                onClick: (item) => navigate(`./${item.id}`)
              },
              /*
              {
                caption: 'Löschen',
                danger: true,
                onClick: (item) => deleteEmployee(item)
              }
                */
            ]
          }}
        />

    </div>
  )
}

export default EmployeePage